/**
 * Where the signed-in session lives: localStorage, shared by every tab.
 *
 * One login covers the whole browser -- open a second tab and it is already
 * signed in, on the same session (Session History), with the same idle clock.
 * Logging out, by hand or automatically, signs every tab out together
 * (app-js/session.js broadcasts it).
 *
 * This used to be sessionStorage, one login per tab, because a background tab
 * reaching the auto-logout used to wipe localStorage under the tab the user was
 * still working in. That can no longer happen: the idle deadline is shared, so
 * every tab reaches it together.
 *
 * Only the keys below are the session. Per-tab UI state (list filters, drafts,
 * expanded panels) stays in sessionStorage.
 */

export const AUTH_KEYS = [
  "token",
  "rtoken",
  "nbfc_Id",
  "user_id",
  "user_name",
  "role",
  "hierarchy_level",
  "user_photo",
  "user_mobile",
  "user_email",
  "user_type",
  "tab_permissions",
  "edit_permissions",
  "userData",
  "orrish.access",
  "orrish.session",
  "orrish.session.deadline",
];

function storage() {
  try {
    return window.localStorage;
  } catch (e) {
    return null;
  }
}

export function getAuth(key) {
  const s = storage();
  try {
    return s ? s.getItem(key) : null;
  } catch (e) {
    return null;
  }
}

export function setAuth(key, value) {
  const s = storage();
  try {
    if (s) s.setItem(key, value == null ? "" : String(value));
  } catch (e) {
    // A full or blocked storage must not break sign-in.
  }
}

export function removeAuth(key) {
  const s = storage();
  try {
    if (s) s.removeItem(key);
  } catch (e) {
    /* ignore */
  }
}

export function clearAuth() {
  AUTH_KEYS.forEach(removeAuth);
}

export function isSignedIn() {
  return !!getAuth("token");
}

export default {
  get: getAuth,
  set: setAuth,
  remove: removeAuth,
  clear: clearAuth,
  isSignedIn,
};
